// True when the server answered with a prerendered public page: its markup is already inside #app.
// The prerender shell marks <html> with data-prerendered; main.js removes it once Vue has mounted.
export const isPrerenderedDocument = !window.__UXFOLIO_PRERENDER__
    && document.documentElement.hasAttribute('data-prerendered');
